export const LocaleSwitchController = {
    switch(): void {},
};
